
const Bio = ({bio} : {bio?:string;}) => {
    return (
        <div className="border shadow border-black/15 sm:pt-12 sm:pb-11 sm:pl-10 sm:pr-14 py-5 pl-5 pr-7 rounded-[18px] mt-8 text-burntBlack">
            <h1 className=" font-bold sm:text-4xl text-lg sm:mb-5 mb-2.5">Short Bio</h1>
            <p className="text-lightGray font-medium sm:text-0.5xl sm:mt-0.5">{bio}</p>
            {/* <h1 className="mb-5 pb-0.5 font-bold text-28px">Skills</h1>
            <div className="max-w-3xl flex gap-x-[14px] gap-y-[18px] flex-wrap">
                <div className="px-[22px] py-2 bg-[#EFF9FF] border-primary/10 border rounded-[36px] text-base text-primary font-medium">Career path</div>
                <div className="px-[22px] py-2 bg-[#EFF9FF] border-primary/10 border rounded-[36px] text-base text-primary font-medium">CMA</div>
                <div className="px-[22px] py-2 bg-[#EFF9FF] border-primary/10 border rounded-[36px] text-base text-primary font-medium">Career path</div>
                <div className="px-[22px] py-2 bg-[#EFF9FF] border-primary/10 border rounded-[36px] text-base text-primary font-medium">Mentoring</div>
                <div className="px-[22px] py-2 bg-[#EFF9FF] border-primary/10 border rounded-[36px] text-base text-primary font-medium">Career path</div>
                <div className="px-[22px] py-2 bg-[#EFF9FF] border-primary/10 border rounded-[36px] text-base text-primary font-medium">Career path</div>
                <div className="px-[22px] py-2 bg-[#EFF9FF] border-primary/10 border rounded-[36px] text-base text-primary font-medium">Career path</div>
                <div className="px-[22px] py-2 bg-[#EFF9FF] border-primary/10 border rounded-[36px] text-base text-primary font-medium">Career path</div>

            </div> */}
        </div>
    )
}

export default Bio